/** Event Management browser routes. */
export const EVENT_MANAGEMENT_BROWSER_ROUTES = {
	EVENT_CREATION: "/event-management/event-creation",
	EVENTS_REQUEST: "/event-management/events-request",
	EVENTS_CLONE: "/event-management/events-clone",
} as const;
